var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2773 12.8734L10.7082 10.1234C10.4044 9.79814 9.98999 9.62073 9.57563 9.62073C9.13364 9.62073 8.7469 9.79814 8.44303 10.1234C8.13916 10.4487 7.97341 10.8922 7.97341 11.3358C7.97341 11.7202 8.08391 12.075 8.27728 12.3707H1.86843C0.984445 12.3707 0.238586 13.1395 0.238586 14.1153C0.238586 15.0615 0.956821 15.8599 1.86843 15.8599H8.24966C7.78004 16.54 7.83529 17.4862 8.4154 18.1072C8.71927 18.4324 9.13364 18.6098 9.548 18.6098C9.98999 18.6098 10.3767 18.4324 10.6806 18.1072L13.2497 15.3572C13.5535 15.0319 13.7193 14.618 13.7193 14.1449C13.7469 13.6422 13.5812 13.1986 13.2773 12.8734Z",
    fill: "#EA345F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.683628 6.36809L3.2527 9.11805C3.55656 9.44331 3.97093 9.62073 4.38529 9.62073C4.82729 9.62073 5.21403 9.44331 5.51789 9.11805C5.82176 8.79278 5.98751 8.34924 5.98751 7.9057C5.98751 7.5213 5.87701 7.16646 5.68364 6.87077H12.0925C12.9765 6.87077 13.7223 6.10196 13.7223 5.12617C13.7223 4.17994 13.0041 3.38157 12.0925 3.38157H5.71127C6.18088 2.70147 6.12563 1.75525 5.54552 1.13429C5.24165 0.809025 4.82728 0.631609 4.41292 0.631609C3.97093 0.631609 3.58419 0.809025 3.28032 1.13429L0.711254 3.88425C0.407386 4.20952 0.241639 4.62349 0.241639 5.0966C0.214014 5.59928 0.37976 6.04282 0.683628 6.36809Z",
    fill: "#EA345F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon2);
export default __webpack_public_path__ + "static/media/transferIcon2.ea050e0ca1aeac83dc9be8aeea27e20b.svg";
export { ForwardRef as ReactComponent };